var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-button',{class:{ active: _vm.isFullscreen },attrs:{"type":_vm.isFullscreen? 'primary' : ''},on:{"click":_vm.fullscreenChange}},[_vm._v(" 全屏显示 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }